import { Box, Typography, Grid, Card } from "@mui/material";
import { useEffect, useState } from "react";
import { getEmergencyContacts } from "../../api/emergencyContacts";
import { useLanguage } from "../../context/LanguageContext";
const INDIA_SAFFRON = "#FF9933";
const INDIA_GREEN = "#138808";
const INDIA_BLUE = "#000080";
const EmergencyContacts = () => {
  const [contacts, setContacts] = useState([]);
  const { language } = useLanguage();

  useEffect(() => {
    fetchContacts();
  }, [language]);

  const fetchContacts = async () => {
    try {
      const data = await getEmergencyContacts(language);
      setContacts(data);
    } catch (error) {
      console.error("Emergency contacts error:", error);
    }
  };

  return (
    <Box
      sx={{
        py: 6,
        px: { xs: 2, md: 4 },
        backgroundColor: "#fff5f5",
      }}
    >
      <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4, md: 5 } }}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem" },
            color: "#1e293b",
            position: "relative",
            display: "inline-block",
            "&:after": {
              content: '""',
              position: "absolute",
              bottom: -8,
              left: "50%",
              transform: "translateX(-50%)",
              width: { xs: 60, sm: 80 },
              height: 3,
              background: `linear-gradient(90deg, ${INDIA_SAFFRON}, ${INDIA_GREEN})`,
              borderRadius: 2,
            }
          }}
        >
          {language === "mr" ? "आपत्कालीन संपर्क" : "Emergency Contacts"}
        </Typography>
      </Box>

      {/* <Typography variant="h5" fontWeight={700} align="center" mb={4}>
       {language === "mr" ? "आपत्कालीन संपर्क" : "Emergency Contacts"}
      </Typography> */}

      <Grid container spacing={3} justifyContent="center">
        {contacts.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <Card
              variant="outlined"
              sx={{
                textAlign: "center",
                borderRadius: 3,
                py: 3,
              }}
            >
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                {item.title}
              </Typography>

              <Typography
                variant="h4"
                fontWeight={800}
                sx={{ color: item.color }}
              >
                {item.number}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EmergencyContacts;
